/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Header } from "@/components/Header";
import { useTranslation } from "react-i18next";
import { CssHome, CssGif, CssPintouParceria, CssViagem, CssNumeros, CssEquipe, CssResultado  } from "./css";
import ReactHtmlParser from "html-react-parser";
import { Footer } from "@/components/Footer";

// CssHome
import setaAzul from "@/assets/cases/conteudoSocial/setaAzul.png";

// Parte 2 agora é video

//Parte 3 Pintou parceria
import logoPintouParceria from "@/assets/cases/jogaJunto/logo-pintou-parceria.png";
import cardPintou1 from "@/assets/cases/jogaJunto/1.png";
import cardPintou2 from "@/assets/cases/jogaJunto/2.png";
import cardPintou3 from "@/assets/cases/jogaJunto/3.png";
import cardPintou4 from "@/assets/cases/jogaJunto/4.png";
import cardPintou5 from "@/assets/cases/jogaJunto/5.png";
import cardPintou6 from "@/assets/cases/jogaJunto/6.png";
import coracao from "@/assets/cases/jogaJunto/coracao.png";
import setaBola from "@/assets/cases/jogaJunto/setaBola.png";
import setaPreta from "@/assets/cases/jogaJunto/seta-preta.png";
import trianguloPintou from "@/assets/cases/jogaJunto/Triangulo-2.png";

// Parte 4 - Viagem
import bgSuvinil from "@/assets/cases/jogaJunto/bgSuvinil.jpg";
import viagemFoto1 from "@/assets/cases/jogaJunto/foto1.jpg";
import viagemFoto2 from "@/assets/cases/jogaJunto/foto2.jpg";
import viagemFoto3 from "@/assets/cases/jogaJunto/foto3.jpg";
import viagemFoto4 from "@/assets/cases/jogaJunto/foto4.jpg";
import viagemFoto5 from "@/assets/cases/jogaJunto/foto5.jpg";

// Parte 5 - Números
import celularNumeros from "@/assets/cases/jogaJunto/celular.png";
import setaBege from "@/assets/cases/jogaJunto/seta-bege.png";
import trianguloAzul from "@/assets/cases/jogaJunto/triangulo-azul.png";
import trianguloCheioAzul from "@/assets/cases/jogaJunto/triangulo-cheio-azul.png";
import zNumeros from "@/assets/cases/jogaJunto/Z.png";
import trianguloNumeros from "@/assets/cases/jogaJunto/Triangulo-2.png";

// Parte 6 - Equipe
import equipe1 from "@/assets/cases/jogaJunto/Equipe1.png";
import equipe2 from "@/assets/cases/jogaJunto/Equipe2.png";
import equipe3 from "@/assets/cases/jogaJunto/Equipe3.png";
import equipe4 from "@/assets/cases/jogaJunto/Equipe4.png";
import equipe5 from "@/assets/cases/jogaJunto/Equipe5.png";
import equipe6 from "@/assets/cases/jogaJunto/Equipe6.png";
import equipe7 from "@/assets/cases/jogaJunto/Equipe7.png";
import equipe8 from "@/assets/cases/jogaJunto/Equipe8.png";

// Parte 7 - Resultado
import quadroResultado from "@/assets/cases/jogaJunto/quadro.jpg";

const CasesJogarJunto = () => {
	const { t } = useTranslation();

	/* ========================= HOME ========================= */
	const homeRef = useRef(null);
	const [animateHome, setAnimateHome] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.25,
		};

		const observerHome = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === homeRef.current) {
						setAnimateHome(true);
					}
				}
			});
		}, observerOptions);

		if (homeRef.current) observerHome.observe(homeRef.current);

		return () => {
			if (homeRef.current) observerHome.unobserve(homeRef.current);
		};
	}, []);

	/* ========================= PARTE 2 ========================= */
	const gifRef = useRef(null);
	const [animateGif, setAnimateGif] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.25,
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === homeRef.current) {
						setAnimateHome(true);
					}

					if (entry.target === gifRef.current) {
						setAnimateGif(true);
					}
				}
			});
		}, observerOptions);

		if (homeRef.current) observer.observe(homeRef.current);
		if (gifRef.current) observer.observe(gifRef.current);

		return () => {
			if (homeRef.current) observer.unobserve(homeRef.current);
			if (gifRef.current) observer.unobserve(gifRef.current);
		};
	}, []);

	/* ========================= PARTE 3 Pintou parceria ========================= */
	const pintouRef = useRef(null);
	const [animatePintou, setAnimatePintou] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.22,
		};

		const observerPintou = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === pintouRef.current) {
						setAnimatePintou(true);
					}
				}
			});
		}, observerOptions);

		if (pintouRef.current) observerPintou.observe(pintouRef.current);

		return () => {
			if (pintouRef.current) observerPintou.unobserve(pintouRef.current);
		};
	}, []);

	/* ========================= PARTE 4 Viagem ========================= */
	const viagemRef = useRef(null);
	const [animateViagem, setAnimateViagem] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.2,
		};

		const observerViagem = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === viagemRef.current) {
						setAnimateViagem(true);
					}
				}
			});
		}, observerOptions);

		if (viagemRef.current) observerViagem.observe(viagemRef.current);

		return () => {
			if (viagemRef.current) observerViagem.unobserve(viagemRef.current);
		};
	}, []);

	/* ========================= PARTE 5 Números ========================= */
	const numerosRef = useRef(null);
	const [animateNumeros, setAnimateNumeros] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.22,
		};

		const observerNumeros = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === numerosRef.current) {
						setAnimateNumeros(true);
					}
				}
			});
		}, observerOptions);

		if (numerosRef.current) observerNumeros.observe(numerosRef.current);

		return () => {
			if (numerosRef.current) observerNumeros.unobserve(numerosRef.current);
		};
	}, []);

	/* ========================= PARTE 6 Equipe ========================= */
	const equipeRef = useRef(null);
	const [animateEquipe, setAnimateEquipe] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.18,
		};

		const observerEquipe = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === equipeRef.current) {
						setAnimateEquipe(true);
					}
				}
			});
		}, observerOptions);

		if (equipeRef.current) observerEquipe.observe(equipeRef.current);

		return () => {
			if (equipeRef.current) observerEquipe.unobserve(equipeRef.current);
		};
	}, []);

	/* ========================= PARTE 7 Resultado ========================= */
	const resultadoRef = useRef(null);
	const [animateResultado, setAnimateResultado] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.18,
		};

		const observerResultado = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === resultadoRef.current) {
						setAnimateResultado(true);
					}
				}
			});
		}, observerOptions);

		if (resultadoRef.current) observerResultado.observe(resultadoRef.current);

		return () => {
			if (resultadoRef.current) observerResultado.unobserve(resultadoRef.current);
		};
	}, []);

	return (
		<>
			<Helmet>
				<title>Zest Ag | Cases | Jogar Junto</title>

				<link rel="shortcut icon" href="https://zest.ag/favicon.png?v=3" />
				<link rel="icon" type="image/png" href="https://zest.ag/favicon.png?v=3" />
				<link rel="apple-touch-icon" href="https://zest.ag/favicon.png?v=3" />

				<meta name="description" content="Zest AG - The full responsa agency" />
				<meta name="keywords" content="Zest One, Agência de marketing, negócios e interesses do cliente, inbound"/>

				<meta property="og:url" content="https://zest.ag/CasesJogarJuntos" />
				<meta property="og:type" content="website" />
				<meta property="og:title" content="Zest Ag | Cases | Jogar Junto" />
				<meta property="og:description" content="Zest Ag - The full responsa agency" />
				<meta property="og:image" content="https://zest.ag/avatar.jpg" />
			</Helmet>

			<Header />
			<div className="clear" />

			{/* ========================= HOME ========================= */}
			<CssHome>
				{/* ========================= PARTE 1 - HOME ========================= */}
				<section
					ref={homeRef}
					className={`caseHero ${animateHome ? "animateParte1" : ""}`}
				>
					<div className="caseContainer">
						

						<div className="jogaJuntoHeroContent">
							<div className="jogaJuntoTitulo animJogaTitulo">
								<h1>
									{ReactHtmlParser(t("casesJogarJunto.titulo"))}
								</h1>

								<h2>
									{ReactHtmlParser(t("casesJogarJunto.subtitulo"))}
								</h2>
							</div>

							<div className="jogaJuntoTexto animJogaTexto">
								{ReactHtmlParser(t("casesJogarJunto.texto"))}
							</div>
						</div>
					</div>
				</section>					
			</CssHome>

			{/* ========================= PARTE 2 - GIF ========================= */}
			<CssGif>
				<section
					ref={gifRef}
					className={`gifSection ${animateGif ? "animateGif" : ""}`}
				>
					<div className="gifWrap">
							<iframe
								src="https://player.vimeo.com/video/1187104319?autoplay=1&muted=1&loop=1&autopause=0"
								title="Vídeo ZEST"
								frameBorder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowFullScreen
							/>
						{/* <img
							src={parte2}
							alt="Joga Junto"
							className="gifImg animGif"
						/> */}
					</div>
				</section>
			</CssGif>

			{/* ========================= PARTE 3 - PINTOU PARCERIA ========================= */}
			<CssPintouParceria>
				<section
					ref={pintouRef}
					className={`pintouSection ${animatePintou ? "animatePintou" : ""}`}
				>
					<div className="pintouContainer">
						<div className="pintouTextoArea">
							<h2 className="pintouTitulo animPintouTitulo">
								{ReactHtmlParser(t("casesJogarJunto.pintouTitulo"))}
							</h2>

							<div className="pintouTexto animPintouTexto">
								{ReactHtmlParser(t("casesJogarJunto.pintouTexto"))}
							</div>
						</div>

						<div className="pintouCardsArea">
							<img
								src={logoPintouParceria}
								alt="Pintou Parceria Suvinil"
								className="pintouLogo animPintouLogo"
							/>

							<img
								src={cardPintou1}
								alt=""
								className="pintouCard pintouCard1 animPintouCard"
							/>

							<img
								src={cardPintou2}
								alt=""
								className="pintouCard pintouCard2 animPintouCard"
							/>

							<img
								src={cardPintou3}
								alt=""
								className="pintouCard pintouCard3 animPintouCard"
							/>

							<div className="pintouCardFade pintouCardFade1 animPintouCard">
								<img src={cardPintou4} alt="" className="pintouCardFadeImg" />
							</div>

							<div className="pintouCardFade pintouCardFade2 animPintouCard">
								<img src={cardPintou5} alt="" className="pintouCardFadeImg" />
							</div>

							<div className="pintouCardFade pintouCardFade3 animPintouCard">
								<img src={cardPintou6} alt="" className="pintouCardFadeImg" />
							</div>
						</div>

						<div className="pintouDecorArea">
							<img
								src={trianguloPintou}
								alt=""
								className="pintouTriangulo"
							/>

							<img
								src={coracao}
								alt=""
								className="pintouCoracao pintouCoracaoLeft animPintouCoracaoLeft"
							/>

							<img
								src={coracao}
								alt=""
								className="pintouCoracao pintouCoracaoRight animPintouCoracaoRight"
							/>

							<img
								src={setaBola}
								alt=""
								className="pintouSetaBola animPintouSetaBola"
							/>

							<img
								src={setaPreta}
								alt=""
								className="pintouSetaPreta pintouSetaPretaTop animPintouSetaPretaRight"
							/>

							<img
								src={setaPreta}
								alt=""
								className="pintouSetaPreta pintouSetaPretaBottom animPintouSetaPretaLeft"
							/>
						</div>
					</div>
				</section>
			</CssPintouParceria>

			{/* ========================= PARTE 4 - VIAGEM ========================= */}
			<CssViagem>
				<section
					ref={viagemRef}
					className={`viagemSection ${animateViagem ? "animateViagem" : ""}`}
					style={{ backgroundImage: `url(${bgSuvinil})` }}
				>
					<div className="viagemContainer">
						<div className="viagemFotosArea">
							<img
								src={viagemFoto1}
								alt=""
								className="viagemFoto viagemFoto1 animViagemFoto"
							/>

							<img
								src={viagemFoto2}
								alt=""
								className="viagemFoto viagemFoto2 animViagemFoto"
							/>

							<img
								src={viagemFoto3}
								alt=""
								className="viagemFoto viagemFoto3 animViagemFoto"
							/>

							<img
								src={viagemFoto4}
								alt=""
								className="viagemFoto viagemFoto4 animViagemFoto"
							/>

							<img
								src={viagemFoto5}
								alt=""
								className="viagemFoto viagemFoto5 animViagemFoto"
							/>
						</div>

						<div className="viagemTexto animViagemTexto">
							{ReactHtmlParser(t("casesJogarJunto.viagemTexto"))}
						</div>
					</div>
				</section>
			</CssViagem>

			{/* ========================= PARTE 5 - NÚMEROS ========================= */}
			<CssNumeros>
				<section
					ref={numerosRef}
					className={`numerosSection ${animateNumeros ? "animateNumeros" : ""}`}
				>
					<div className="numerosContainer">
						<img
							src={trianguloAzul}
							alt=""
							className="numerosTrianguloAzul animNumerosTrianguloAzul"
						/>

						<img
							src={setaBege}
							alt=""
							className="numerosSetaBege animNumerosSetaBege"
						/>

						<img
							src={celularNumeros}
							alt=""
							className="numerosCelular animNumerosCelular"
						/>

						<div className="numerosStat numerosStat15 animNumeros15">
							<strong>+15k</strong>
							<span>{ReactHtmlParser(t("casesJogarJunto.numeros15Texto"))}</span>
						</div>

						<div className="numerosStat numerosStat100 animNumeros100">
							<strong>+100</strong>
							<span>{ReactHtmlParser(t("casesJogarJunto.numeros100Texto"))}</span>
						</div>

						<div className="numerosStat numerosStat20 animNumeros20">
							<strong>+20</strong>
							<span>{ReactHtmlParser(t("casesJogarJunto.numeros20Texto"))}</span>
						</div>

						<img
							src={trianguloCheioAzul}
							alt=""
							className="numerosTrianguloCheioAzul animNumerosTrianguloCheioAzul"
						/>

						<img
							src={zNumeros}
							alt=""
							className="numerosZ animNumerosZ"
						/>

						<img
							src={trianguloNumeros}
							alt=""
							className="numerosTrianguloBege animNumerosTrianguloBege"
						/>
					</div>
				</section>

				
			</CssNumeros>

			{/* ========================= PARTE 6 - EQUIPE ========================= */}
			<CssEquipe>
				<section
					ref={equipeRef}
					className={`equipeSection ${animateEquipe ? "animateEquipe" : ""}`}
				>
					<div className="equipeContainer">
						<h2 className="equipeTitulo animEquipeTitulo">
							{ReactHtmlParser(t("casesJogarJunto.equipeTitulo"))}
						</h2>

						<div className="equipeFotosArea">
							<img
								src={equipe1}
								alt=""
								className="equipeFoto equipeFoto1 animEquipeFoto"
							/>

							<img
								src={equipe2}
								alt=""
								className="equipeFoto equipeFoto2 animEquipeFoto"
							/>

							<img
								src={equipe3}
								alt=""
								className="equipeFoto equipeFoto3 animEquipeFoto"
							/>

							<img
								src={equipe4}
								alt=""
								className="equipeFoto equipeFoto4 animEquipeFoto"
							/>

							<img
								src={equipe5}
								alt=""
								className="equipeFoto equipeFoto5 animEquipeFoto"
							/>

							<img
								src={equipe6}
								alt=""
								className="equipeFoto equipeFoto6 animEquipeFoto"
							/>

							<img
								src={equipe7}
								alt=""
								className="equipeFoto equipeFoto7 animEquipeFoto"
							/>

							<img
								src={equipe8}
								alt=""
								className="equipeFoto equipeFoto8 animEquipeFoto"
							/>
						</div>
					</div>
				</section>

				
			</CssEquipe>

			{/* ========================= PARTE 7 - RESULTADO ========================= */}
			<CssResultado>
				<section
					ref={resultadoRef}
					className={`resultadoSection ${animateResultado ? "animateResultado" : ""}`}
				>
					<div className="resultadoContainer">
						<div className="resultadoQuadroWrap animResultadoQuadro">
							<img
								src={quadroResultado}
								alt=""
								className="resultadoQuadro"
							/>
						</div>

						<div className="resultadoTextoArea animResultadoTexto">
							<h2>
								{ReactHtmlParser(t("casesJogarJunto.resultadoTitulo"))}
							</h2>

							<h3>
								{ReactHtmlParser(t("casesJogarJunto.resultadoSubtitulo"))}
							</h3>

							<div className="resultadoTexto">
								{ReactHtmlParser(t("casesJogarJunto.resultadoTexto"))}
							</div>
						</div>

						<div className="resultadoStat resultadoStat15 animResultado15">
							<strong>+300</strong>
							<span>{ReactHtmlParser(t("casesJogarJunto.resultado15Texto"))}</span>
						</div>

						<div className="resultadoStat resultadoStat20 animResultado20">
							<strong>+15</strong>
							<span>{ReactHtmlParser(t("casesJogarJunto.resultado20Texto"))}</span>
						</div>
					</div>
				</section>

				<div className="caseTop">
					<a href="/CasesConteudoSocial" className="caseNav caseNavHome">
						<img src={setaAzul} alt="" />
						<span>{t("botoes.voltar")}</span>
					</a>
					<a href="/CasesCampanhas" className="caseNav caseNavNext">
						<span>{t("casesConteudoSocial.proximoCase")}</span>
						<img src={setaAzul} alt="" />
					</a>
					
				</div>
			</CssResultado>

		
			<div className="clear" />
			<Footer />
		</>
	);
};

export default CasesJogarJunto;